interface EmptyStateProps {
  title: string;
  description?: string;
}

/** 空列表状态 */
export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className="rounded-[var(--radius-md)] border border-dashed border-border bg-bg-card/50 px-6 py-12 text-center">
      <p className="text-[14px] font-medium text-fg-muted">{title}</p>
      {description ? (
        <p className="mt-1 text-[13px] text-fg-subtle">{description}</p>
      ) : null}
    </div>
  );
}
